import Vue from 'vue'

export const deleteSuccess = (property, plural) => {
  return (state, payload) => {
    state[property] = {}
    if (plural && state[plural]) {
      state[plural] = state[plural].filter(item => payload.data.id !== item.id)
    }
    else if (state[property + 's']?.length) {
      state[property + 's'] = state[property + 's'].filter(item => payload.data.id !== item.id)
    }
  }
}

export const updateSuccess = (property, plural) => {
  return (state, payload) => {
    if (state[plural]?.length) {
      const itemIndex = state[plural].findIndex(item => item.id === payload.data.id)
      if (itemIndex > -1) {
        Vue.set(state[plural], itemIndex, payload.data)
      }
    }
    state[property] = payload.data
  }
}

export const createSuccess = (property, plural) => {
  return (state, payload) => {
    if (!state[plural]) {
      state[plural] = []
    }
    state[plural].push(payload.data)
    state[property] = payload.data
  }
}

export const beforeRequestReset = (property, depKeys, initialState) => {
  return (state, payload, axios) => {
    // Set state to initial state while loading so UI will not show it
    if (property) {
      state[property] = initialState[property]
    }
    // Reset dependent resources so there is no stale data
    for (let i = 0; i < depKeys.length; i++) {
      state[depKeys[i]] = initialState[depKeys[i]]
    }
  }
}
